import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { testUrl } from "../home/BaseData";
import styles from "./PhoneForm.module.css";
import Head from "../../shared/layout/head/Head";

const PhoneForm = () => {
    const navigate = useNavigate();
    const [phone, setPhone] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [success, setSuccess] = useState(false);

    const formatPhone = (value) => {
        const digits = value.replace(/[^\d+]/g, "");
        return digits;
    };

    const handleChange = (e) => {
        setPhone(formatPhone(e.target.value));
        if (error) setError("");
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!phone || phone.length < 9) {
            setError("Iltimos, to'g'ri telefon raqam kiriting.");
            return;
        }
        setLoading(true);
        try {
            await axios.post(`${testUrl}/api/phone-leads/`, { phone_number: phone });
            setSuccess(true);
            setTimeout(() => {
                navigate("/");
            }, 2000);
        } catch (err) {
            setError("Xatolik yuz berdi. Iltimos, qayta urinib ko'ring.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className={styles.pageContainer}>
            <Head title="Bog'lanish uchun raqam qoldirish" />
            <div className={styles.contentWrapper}>
                <div className={styles.card}>
                    {success ? (
                        <div className={styles.successState}>
                            <div className={styles.successIcon}>✓</div>
                            <h2 className={styles.successTitle}>Rahmat!</h2>
                            <p className={styles.successText}>
                                Raqamingiz muvaffaqiyatli qabul qilindi. Mutaxassislarimiz siz bilan tez orada bog'lanishadi.
                            </p>
                        </div>
                    ) : (
                        <>
                            <div className={styles.header}>
                                <h1 className={styles.title}>Ariza topshirish</h1>
                                <p className={styles.subtitle}>
                                    Ariza topshirish uchun telefon raqamingizni qoldiring.
                                </p>
                            </div>

                            <form onSubmit={handleSubmit} className={styles.form}>
                                <div className={styles.inputGroup}>
                                    <label htmlFor="phone" className={styles.label}>
                                        Telefon raqam
                                    </label>
                                    <input
                                        id="phone"
                                        type="tel"
                                        className={styles.input}
                                        placeholder="+998 90 123 45 67"
                                        value={phone}
                                        onChange={handleChange}
                                        maxLength={15}
                                    />
                                    {error && <span className={styles.error}>{error}</span>}
                                </div>
                                <button type="submit" className={styles.submitBtn} disabled={loading}>
                                    {loading ? "Yuborilmoqda..." : "Yuborish"}
                                </button>
                            </form>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default PhoneForm;
